import { rem } from 'polished';
import styled from 'styled-components';

export const ModalContent = styled.div`
  background: ${({ theme }) => theme.colors.modal.background};
  padding: ${rem(32)};

  h2 {
    font-size: ${rem(20)};
    font-weight: 600;
    margin-bottom: ${rem(24)};
  }

  p {
    font-size: ${rem(16)};
    margin-bottom: ${rem(16)};
    line-height: 140%;

    &:last-of-type {
      margin-bottom: 0;
    }
  }

  .ctas {
    list-style: none;
    margin: ${rem(24)} 0 0 0;
    padding: 0;
    display: flex;
    flex-flow: row;
    justify-content: space-between;

    li:last-of-type {
      button {
        background: ${({ theme }) =>
          theme.colors.modal.cta.destructive.background};
        border-color: ${({ theme }) =>
          theme.colors.modal.cta.destructive.border};

        &:hover,
        &:focus {
          background: ${({ theme }) => theme.colors.cta.destructive.background};
          border-color: ${({ theme }) => theme.colors.cta.destructive.border};
        }
      }
    }
  }

  .alert {
    margin-bottom: ${rem(25)};
  }
`;
